// src/pages/TermsOfService.jsx
import React from 'react';
import NavBar from '../NavBar';
import Footer from '../Footer';
import { useTranslation } from 'react-i18next';

const COMPANY = {
  name: 'Real Estate App Co., Ltd.',
  effective: '1 January 2025',
  email: 'contact@realestateapp.com',
  phone: '081-234-5678',
};

export default function TermsOfService() {
  const { t } = useTranslation();

  return (
    <div style={styles.wrapper}>
      <NavBar />
      <main style={styles.container}>
        <h1 style={styles.header}>{t('terms.title')}</h1>
        <p style={styles.meta}>{t('terms.effective')}: {COMPANY.effective}</p>

        <section style={styles.section}>
          <h2 style={styles.h2}>{t('terms.section1_title')}</h2>
          <p style={styles.p}>
            {t('terms.section1_text', { company: COMPANY.name })}
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>{t('terms.section2_title')}</h2>
          <ul style={styles.ul}>
            <li>{t('terms.section2_point1')}</li>
            <li>{t('terms.section2_point2')}</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>{t('terms.section3_title')}</h2>
          <p style={styles.p}>
            {t('terms.section3_text')}
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>{t('terms.section4_title')}</h2>
          <p style={styles.p}>
            {t('terms.section4_text', { company: COMPANY.name })}
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>{t('terms.section5_title')}</h2>
          <p style={styles.p}>
            {t('terms.section5_text')}
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>{t('terms.section6_title')}</h2>
          <p style={styles.p}>
            {t('terms.section6_text')}
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>{t('terms.section7_title')}</h2>
          <p style={styles.p}>
            {t('terms.section7_email')}: <a href={`mailto:${COMPANY.email}`} style={styles.link}>{COMPANY.email}</a><br />
            {t('terms.section7_phone')}: <a href={`tel:${COMPANY.phone}`} style={styles.link}>{COMPANY.phone}</a>
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}

const styles = {
  wrapper: { display: 'flex', flexDirection: 'column', minHeight: '100vh', background: '#f7f9fb' },
  container: {
    flex: 1,
    width: '100%',
    maxWidth: 900,
    margin: '20px auto',
    padding: '24px',
    background: '#fff',
    borderRadius: 12,
    boxShadow: '0 8px 20px rgba(0,0,0,0.06)',
    boxSizing: 'border-box',
  },
  header: {
    fontSize: '36px',
    fontWeight: '800',
    marginBottom: '10px',
    color: '#1a2e35',
    letterSpacing: '1.2px',
    textTransform: 'uppercase',
    textAlign: 'center',
    borderBottom: '3px solid #dd9e2a',
    paddingBottom: '8px',
  },
  meta: { textAlign: 'center', color: '#66788a', marginBottom: 18 },
  section: { marginTop: 18 },
  h2: { fontSize: 20, fontWeight: 700, color: '#0f1f2e', marginBottom: 8 },
  p: { fontSize: 16, color: '#2c3e50', lineHeight: 1.8 },
  ul: { paddingLeft: 20, margin: 0, color: '#2c3e50', lineHeight: 1.8 },
  link: { color: '#0d6efd', textDecoration: 'none' },
};
